(function (app, ng) {

    app.controller("editPlanningEventController", editPlanningEventController);
    editPlanningEventController.$inject = ["$mdDialog", "$q", "eventGroupApi", "ancillaryEventGroupApi", "$timeout", "_formPattern", "moment"];
    function editPlanningEventController($mdDialog, $q, eventGroupApi, ancillaryEventGroupApi, $timeout, formPattern, moment) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    saving: false
                },
                stats: {},
                close: close,
                deleteEvent: deleteEvent,
                update: update,
                hasSaved: false,
                showSavedMessage: showSavedMessage,
                formPattern: formPattern
            });

        function close() {
            $mdDialog.hide({
                eventGroup: $ctrl.eventGroup,
                event: $ctrl.event
            });
        }

        function deleteEvent($event) {
            var confirm = $mdDialog.confirm({
                theme: "confirmDelete",
                title: "Are you sure you want to delete this event?",
                targetEvent: $event,
                ariaLabel: "Confirm event removal",
                ok: "Delete",
                cancel: "Cancel",
                skipHide: true,
                multiple: true,
                onComplete: function() {
                    var $dialog = ng.element(document.querySelector("md-dialog"));
                    var $actionsSection = $dialog.find("md-dialog-actions");
                    var $cancelButton = $actionsSection.children()[0];
                    $cancelButton.focus();
                }
            });

            $mdDialog.show(confirm).then(function () {
                $ctrl.ui.deleting = true;
                if (!$ctrl.eventGroup.EventType.IsAncillary) {
                    return eventGroupApi.deleteEvent($ctrl.eventGroup.Id, $ctrl.event.Id).then(function () {
                        $ctrl.ui.deleting = false;
                        return $mdDialog.hide({
                            eventGroupId: $ctrl.eventGroup.Id,
                            eventId: $ctrl.event.Id,
                            toDelete: true
                        });
                    });
                }
                return ancillaryEventGroupApi.deleteAncillaryEvent($ctrl.eventGroup.Id, $ctrl.event.Id)
                    .then(function () {
                        $ctrl.ui.deleting = false;
                        return $mdDialog.hide({
                            eventGroupId: $ctrl.eventGroup.Id,
                            eventId: $ctrl.event.Id,
                            toDelete: true
                        });
                    });
            });
        }

        function showSavedMessage() {
            $ctrl.hasSaved = true;
            $timeout(function () {
                $ctrl.hasSaved = false;
            }, 3000);
        }

        function update() {
            $ctrl.ui.saving = true;
            $ctrl.event.EventDate = new Date($ctrl.ui.eventDate);

            if (!$ctrl.eventGroup.EventType.IsAncillary) {
                eventGroupApi.update($ctrl.eventGroup.Id, $ctrl.eventGroup).then(function () {
                    eventGroupApi.updateEvent($ctrl.eventGroup.Id, $ctrl.event.Id, $ctrl.event).then(function () {
                        $ctrl.ui.saving = false;
                        showSavedMessage();
                    });
                });
            } else {
                ancillaryEventGroupApi.update($ctrl.eventGroup.Id, $ctrl.eventGroup).then(function () {
                    ancillaryEventGroupApi.updateAncillaryEvent($ctrl.eventGroup.Id, $ctrl.event.Id, $ctrl.event).then(function () {
                        $ctrl.ui.saving = false;
                        showSavedMessage();
                    });
                });
            }
        }

        $ctrl.$onInit = () => {
            $ctrl.ui.eventDate = moment($ctrl.event.EventDate).format("L");
        }
    }
})(window.app, window.angular); //jshint ignore:line